<template>
  <span v-if="direction == 'desc'"><i class="fas fa-sort-down"></i></span>
  <span v-else><i class="fas fa-sort-up"></i></span>
</template>
<script>
export default {
  props: ['direction']
}
</script>